<template>
  <generic-modal :modal-key="'resume_game'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>
      <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
      <p>{{ getTranslations.home_modals_resume_game_msg_to_continue_the_game }}</p>
      <button type="" @click.prevent="resumeGame()">
        {{ getTranslations.home_modals_resume_game_resume_game }}
      </button>
    </template>
  </generic-modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'resume-game',
  components: { GenericModal },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'setGameResuming',
      'setTransitionOnlyForSearchingToOpponent',
    ]),
    resumeGame() {
      this.setGameResuming(true);
      this.storeModalForHomePage(null);
      if (this.transitionOnlyForSearchingToOpponent) {
        this.setTransitionOnlyForSearchingToOpponent(false);
      }
      this.checkIfGameToResumeExists().then(() => {
        if (this.gameInProgress) {
          this.$router.replace('/resumingGame');
        } else {
          this.getUserLoginDetails().then(() => {
            this.closeResumeGameModal();
          });
        }
      });
    },
    closeResumeGameModal() {
      this.$emit('close');
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'transitionOnlyForSearchingToOpponent',
      'playersDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGame.vue